import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { PdfPreviewContent } from "../PdfPreviewContent";
import PdfPreviewHeading from "../PdfPreviewHeading";
import PdfPreviewHeader from "../PdfPreviewHeader";
import { CreateStudentType } from "../../types/Student";
import { useEffect } from "react";
import { BASE_URL, UPLOAD_IMAGES } from "../../utils/constants";
import { useIES } from "../../hooks/useIES";


export const StudentProcess = () => {
  const { IES, isLoading } = useIES();
  const updateEnrollmentDataLS = localStorage.getItem("updateEnrollmentData");
  const preloadedupdateEnrollmentData: CreateStudentType = updateEnrollmentDataLS ? JSON.parse(updateEnrollmentDataLS) : undefined;

  const enrollmentDataFromState = useSelector((state: RootState) => state.student);
  const enrollmentData = preloadedupdateEnrollmentData || enrollmentDataFromState;

  const currentDate = new Date().toLocaleDateString('pt-BR');
  const userData = useSelector((state: RootState) => state.login.userData)
  const enrollmentDataCloned = { ...enrollmentData } as any;

  useEffect(() => {
    localStorage.removeItem("pdfPreviewTypeData_SP");
    localStorage.removeItem("updateEnrollmentData");
  }, []);

  return (
    <>
      <PdfPreviewContent>
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <img
            src={`${IES.LOGO}`}
            alt="IES Logo"
            style={{ width: "100px", height: "auto" }}
          />
        </div>
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          <h1 style={{ fontSize: "14px", marginBottom: "5px" }}>
            {IES.NAME}
          </h1>
          <h2
            style={{
              fontSize: "12px",
              borderTop: "1px solid #000",
              borderBottom: "1px solid #000",
              padding: "2px 0",
              margin: "5px 0",
            }}
          >
            DIRECÇÃO DOS SERVIÇOS ESTUDANTIS E REGISTO ACADÉMICO        </h2>
          <h3
            style={{
              fontSize: "12px",
              border: "1px solid #000",
              padding: "2px 0",
              margin: "5px 0",
            }}
          >
            FICHA DE MATRÍCULA
          </h3>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "15px",
            color: "blue",
          }}
        >
          {/* <span>
          Inscrição nº:{" "}
          <span style={{ border: "1px solid #000", padding: "2px 5px" }}>
            00000000000000022169
          </span>
        </span> */}
          <span>Original</span>
          <span>Emitido em: {currentDate}</span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
          }}
        >
          <span>Dados do Estudante:</span>
          <span>Ano Lectivo: {enrollmentData.enrollment?.academicYear} </span>
        </div>
        <div style={{ marginBottom: "15px", borderBottom: "1px solid #000", borderTop: "1px solid #000", padding: "10px 0" }}>
          <div style={{ marginTop: "5px" }}>
            <p>Estudante: {enrollmentData.student?.fullname} Nº: {enrollmentData.student?.schoolCode}</p>
            <p>Curso: {enrollmentData.enrollment?.course}</p>
            <p>Delegação: {enrollmentData.enrollment?.departament} Campus: {enrollmentData?.enrollment?.faculty}</p>
          </div>
        </div>

        {enrollmentData?.payment?.reference ? <>
          <div style={{ marginBottom: "10px", padding: "10px 0" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              <span>INFORMAÇÃO PARA PAGAMENTO: </span>
            </div>
            <div style={{ marginTop: "5px" }}>
              <p>Entidade: {enrollmentData?.payment?.entity}, Referencia: {enrollmentData?.payment?.reference}, Valor: {enrollmentData?.payment?.totalPrice} MT, Banco: {enrollmentData?.payment?.bankDescription} - {enrollmentData?.payment?.bankName} </p>
            </div>
          </div>

        </> : <>
          <div style={{ marginTop: "5px" }}>
            <p>Valor pago via Comprovativo</p>
          </div>
        </>}
        <div style={{ marginBottom: "15px" }}>
          <p>
            Por meio desta, confirma-se que o estudante acima tem a matrícula efectuada
            para o ano lectivo de {enrollmentData.enrollment?.academicYear}.
          </p>
        </div>


        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <div
            style={{
              width: "300px",
              borderTop: "1px solid #000",
              margin: "0 auto 5px",
            }}
          ></div>
          <span>{userData?.Fullname} | {userData?.Role}</span>
        </div>

        {/* Rodapé */}
        <div style={{ fontSize: "10px", color: "blue", textAlign: "center" }}>
          <p>Impresso no dia {currentDate}</p>
        </div>


        <div style={{ borderTop: "1px solid #000", padding: "10px 5px" }}>
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <img
         src={`${IES.LOGO}`}
              alt="IES Logo"
              style={{ width: "100px", height: "auto" }}
            />
          </div>
          <div style={{ textAlign: "center", marginBottom: "15px" }}>
            <h1 style={{ fontSize: "14px", marginBottom: "5px" }}>
             {IES.NAME}
            </h1>
            <h2
              style={{
                fontSize: "12px",
                borderTop: "1px solid #000",
                borderBottom: "1px solid #000",
                padding: "2px 0",
                margin: "5px 0",
              }}
            >
              DIRECÇÃO DOS SERVIÇOS ESTUDANTIS E REGISTO ACADÉMICO        </h2>
            <h3
              style={{
                fontSize: "12px",
                border: "1px solid #000",
                padding: "2px 0",
                margin: "5px 0",
              }}
            >
              FICHA DE MATRÍCULA
            </h3>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "15px",
              color: "blue",
            }}
          >
            {/* <span>
          Inscrição nº:{" "}
          <span style={{ border: "1px solid #000", padding: "2px 5px" }}>
            00000000000000022169
          </span>
        </span> */}
            <span>Original</span>
            <span>Emitido em: {currentDate}</span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "bold",
            }}
          >
            <span>Dados do Estudante:</span>
            <span>Ano Lectivo: {enrollmentData.enrollment?.academicYear} </span>
          </div>
          <div style={{ marginBottom: "15px", borderBottom: "1px solid #000", borderTop: "1px solid #000", padding: "10px 0" }}>

            <div style={{ marginTop: "5px" }}>
              <p>Estudante: {enrollmentData.student?.fullname} Nº: {enrollmentData.student?.schoolCode}</p>
              <p>Curso: {enrollmentData.enrollment?.course}</p>
              <p>Delegação: {enrollmentData.enrollment?.departament} Campus: {enrollmentData?.enrollment?.faculty}</p>
            </div>
          </div>
          {enrollmentData?.payment?.reference ? <>
            <div style={{ marginBottom: "10px", padding: "10px 0" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <span>INFORMAÇÃO PARA PAGAMENTO: </span>
              </div>
              <div style={{ marginTop: "5px" }}>
                <p>Entidade: {enrollmentData?.payment?.entity}, Referencia: {enrollmentData?.payment?.reference}, Valor: {enrollmentData?.payment?.totalPrice} MT, Banco: BCI </p>
              </div>
            </div>

          </> : enrollmentData?.payment?.paymentProof ? <>
            <div style={{ marginTop: "5px" }}>
              <p>Valor pago via Comprovativo</p>
            </div>
          </> : <>
          </>}
          <div style={{ marginBottom: "15px" }}>
            <p>
              Por meio desta, confirma-se que o estudante acima tem a matrícula efectuada
              para o ano lectivo de {enrollmentData.enrollment?.academicYear}.
            </p>
          </div>


          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div
              style={{
                width: "300px",
                borderTop: "1px solid #000",
                margin: "0 auto 5px",
              }}
            ></div>
            <span>{userData?.Fullname} | {userData?.Role}</span>
          </div>

          {/* Rodapé */}
          <div style={{ fontSize: "10px", color: "blue", textAlign: "center" }}>
            <p>Impresso no dia {currentDate}</p>
          </div>
        </div>
      </PdfPreviewContent>

    </>
  );
};

export default StudentProcess;